<template>
    <div>
        <!--Control Component -->
        <b-input-group @click="is_visible = true" v-if="isModal">
            <b-form-input readonly :value="sectionString"></b-form-input>
            <b-input-group-append>
                <b-button v-b-modal.locationSubModal variant="outline-primary">
                    <b-icon icon="arrows-angle-expand"></b-icon>
                </b-button>
            </b-input-group-append>
        </b-input-group>

        <!--Modal Component -->
        <b-modal
            v-if="isModal"
            v-model="is_visible"
            :title="modalTitle"
            hide-footer
            size="lg"
        >
            <portal-target name="locationSectionComp"></portal-target>
        </b-modal>

        <!--Section Component -->
        <portal
            to="locationSectionComp"
            :disabled="!isModal || !is_visible"
            v-show="!isModal || is_visible"
        >
            <b-card :title="title" title-tag="h6">
                <div v-show="searchMode">
                    <b-row no-gutters>
                        <b-col cols="8">
                            <vue-typeahead-bootstrap
                                v-model="searchedLocationName"
                                :data="searchedLocations"
                                :serializer="
                                    s =>
                                        s.address1 +
                                        ', ' +
                                        s.address2 +
                                        ', ' +
                                        s.city
                                "
                                @hit="setSearchedLocation"
                                @input="lookupSearchedLocations"
                                placeholder="Search Existing Locations..."
                            />
                        </b-col>
                        <b-col>
                            <b-button
                                block
                                variant="outline-primary"
                                @click="setCreateLocationMode"
                                >Create Location</b-button
                            >
                        </b-col>
                    </b-row>
                </div>

                <location-view
                    v-show="!searchMode"
                    :location-data="location"
                    :section-only="true"
                    :hide-controls="true"
                    :loading="loading"
                    @cancel="$emit('cancel')"
                    @update-location-model="triggerUpdateLocation"
                >
                    <template #default>
                        <b-button
                            :disabled="disabled"
                            v-if="!hideControls"
                            class="mr-2"
                            variant="secondary"
                            @click="setSearchMode"
                            >Change Location</b-button
                        >
                        <slot
                            :hide-modal="hideModal"
                            :set-search-mode="setSearchMode"
                        ></slot>
                    </template>
                    <template #section>
                        <b-form-group
                            id="section-name-group"
                            label="Section Name:"
                            label-for="section-name"
                            label-cols="2"
                        >
                            <b-form-input
                                id="section-name"
                                v-model="section_name"
                                :readonly="disabled"
                                placeholder="Enter Section Name"
                            ></b-form-input>
                        </b-form-group>
                    </template>
                </location-view>
            </b-card>
        </portal>
    </div>
</template>

<script>
import EventBus from '@/exports/event-bus.js'
import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'

import { debounce } from 'lodash'
import LocationView from './LocationView'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'LocationSection',
    components: { LocationView, VueTypeaheadBootstrap },
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            currentSection: { name: '', location: {} },
            section_name: '',
            searchMode: false,
            searchedLocationName: '',
            location: null,
            is_visible: false,
        }
    },

    props: {
        value: { type: Number },
        hideControls: { type: Boolean },
        title: { type: String },
        disabled: { type: Boolean },
        loading: { type: Boolean },
        modalTitle: { type: String },
        isModal: { type: Boolean },
    },
    computed: {
        searchedLocations() {
            const searchedLocations = this.$store.state.locations.locations
            console.log('searchedLocations', searchedLocations)
            return searchedLocations
        },

        sectionString() {
            const { section_name, location } = this
            let { address1, address2 } = location || {}
            address1 = address1 || ''
            address2 = address2 || ''
            return address1 || address2
                ? `${section_name}, ${
                      address1 && address2
                          ? address1 + ', ' + address2
                          : address1
                          ? address1
                          : address2
                  }`
                : 'Click to Select Location'
        },
    },
    watch: {
        sectionString: function (to, from) {
            console.log('watch sectionString', { to, from })
        },
        ///////////////////////

        'currentSection.id': function (to, from) {
            console.log('watch current section id', { to, from })
            this.$emit('input', to)
        },

        section_name: function (section_name, from) {
            const { location, currentSection } = this
            console.log('current section name', {
                section_name,
                from,
            })

            if (
                section_name &&
                section_name ==
                    (currentSection && currentSection.id && currentSection.name)
            ) {
                this.$emit('input', currentSection.id)
            } else {
                this.$set(this.currentSection, 'id', null)
                this.$emit('input', null)
            }

            this.$emit('update-section-model', {
                section_name,
                location,
            })
        },

        'currentSection.location': {
            handler: function (_location) {
                const { location } = this
                console.log('watch currentSection.location', _location)
                if ((_location && _location.id) || (location && location.id)) {
                    this.parseLocation(
                        _location,
                        'currentSection location watch'
                    )
                }
            },
            deep: true,
        },

        //////////////////////////////////

        location: {
            handler: function (location, from) {
                console.log('location --watching', { location, from })
                const { section_name } = this
                this.$emit('update-section-model', { section_name, location })
            },
            deep: true,
        },

        value: function (to, from) {
            console.log('value--watching', { to, from })
            this.setSection(to)
        },
    },
    created() {
        EventBus.$on('set-location-search-mode', () => {
            this.setSearchMode()
        })
    },
    mounted() {
        console.log('locationSection---mounting')
        this.setSection(this.value)
    },
    methods: {
        hideModal() {
            this.is_visible = false
        },
        lookupSearchedLocations: debounce(function () {
            // in practice this action should be debounced
            const { searchedLocationName: query } = this
            const page = 1
            this.$store.dispatch('locations/fetchLocations', {
                query,
                page,
            })
        }, 500),

        resetCurrentSection() {
            for (let key in this.currentSection) {
                if (key == 'name') {
                    this.$set(this.currentSection, 'name', '')
                    this.section_name = ''
                } else if (key == 'location')
                    this.$set(this.currentSection, 'location', {})
                else this.$delete(this.currentSection, key)
            }
        },

        setSearchMode() {
            this.searchedLocationName = ''
            this.resetCurrentSection()
            this.searchMode = true
        },
        setCreateLocationMode() {
            this.resetCurrentSection()
            this.searchMode = false
        },

        setSearchedLocation(location) {
            console.log('location', location)
            this.currentSection = this.currentSection || { name: '' }
            this.$set(this.currentSection, 'location', location)
            this.searchMode = false

            this.genericToast(
                'Location Section',
                'Added',
                'success',
                `Location Section successfully added`
            )
        },

        async setSection(id) {
            console.log('setSection----id', id)
            if (id) {
                const section = await this.$store.dispatch(
                    'locations/getSection',
                    id
                )

                this.currentSection = section
                this.section_name = section.name
                this.searchMode = false
            } 


        
        },

        parseLocation(
            {
                id,
                name,
                address1,
                address2,
                city,
                postal_code,
                state_name,
                zip_code,
                country_code,
                latitude,
                longitude,
                map_reference,
                is_warehouse,
            },
            trigger
        ) {
            console.log('parseLocation trigger', trigger)
            this.location = {
                id,
                name,
                address1,
                address2,
                city,
                state_name,
                zip_code,
                postal_code,
                country_code,
                latitude,
                longitude,
                map_reference,
                is_warehouse,
            }
        },

        triggerUpdateLocation(_location) {
            const {
                currentSection: { location, id, name },
            } = this
            if (!_location.id || _location.id != (location && location.id)) {
                if (location || id || name) {
                    this.$set(this.currentSection, 'id', null)
                    this.$set(this.currentSection, 'name', '')
                    this.$set(this.currentSection, 'location', null)
                }
                this.parseLocation(_location, 'triggerUpdateLocation')
            }
            
            
          
            console.log('triggerUpdateLocation', _location)
        },
    },
}
</script>
